import { useLazyQuery } from '@apollo/client';
import { gql } from '@apollo/client/core';

const SELLER_CONSOLE_LINK_QUERY = gql`
  query SellerConsoleLink($landingUrl: String) {
    sellerConsoleLink(landingUrl: $landingUrl) {
      url
    }
  }
`;

export const useGetSellerConsoleLink = () => {
  const [fetchConsoleLink, { loading, error, data }] = useLazyQuery(
    SELLER_CONSOLE_LINK_QUERY,
    { fetchPolicy: 'network-only' }
  );

  const getConsoleLink = async (landingUrl = null) => {
    const result = await fetchConsoleLink({
      variables: { landingUrl },
    });
    return result;
  };

  return { loading, error, data, getConsoleLink };
};
